import { cloneElement, type ReactElement, type ReactNode, useMemo, useState } from 'react';
import { DialogContext } from './DialogContext';

export const DialogProvider = ({ children }: {
    children: ReactNode;
}) => {
    const [openedDialogs, setOpenedDialogs] = useState<Array<ReactElement>>([]);

    const value = useMemo(
        () => ({
            isOpened: Boolean(openedDialogs.length),
            numberOfOpenDialogs: openedDialogs.length,
            closeAllDialogs: () => setOpenedDialogs([]),
            closeLastDialog: () => setOpenedDialogs((prevState) => prevState.slice(0, -1)),
            openNewDialog: (dialog: ReactElement) => {
                setOpenedDialogs((prevState) => {
                    const cloned = cloneElement(dialog, {
                        key: prevState.length,
                    });
                    return [...prevState, cloned];
                });
            },
        }),
        [openedDialogs.length]
    );

    return (
        <DialogContext.Provider value={value}>
            {children}
            {openedDialogs}
        </DialogContext.Provider>
    );
};
